import { Avatar, Group, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@sloyd/icons';
import { forwardRef } from 'react';
import classes from './UserButton.module.css';

export type UserButtonProps = {
  image: string;
  name: string;
  email: string;
  icon?: React.ReactNode;
};

export const UserButton = forwardRef<HTMLButtonElement, UserButtonProps>(
  ({ image, name, email, icon, ...others }: UserButtonProps, ref) => (
    <UnstyledButton ref={ref} {...others}>
      <Group wrap='nowrap' className={classes.wrapper}>
        <Avatar src={image} size={24} radius='md' />

        <div style={{ flex: 1 }}>
          <Text size='sm' fw={500} className={classes.name}>
            {name}
          </Text>

          <Text c='dimmed' size='xs' className={classes.email}>
            {email}
          </Text>
        </div>

        {icon || <IconChevronRight size='16px' />}
      </Group>
    </UnstyledButton>
  )
);

export default UserButton;
